import { setSerial, getSerial } from '../caching';

const persistSerialToCache = async (serial: string): Promise<void> => {
    try {
        return await setSerial('serial', serial);
    } catch (err) {
        logger.error('[@fingermarkglobal/serial] Error in persistSerialToCache:', err);
    }
}

const retrieveSerialFromCache = async (): Promise<null | string> => {
    try {
        return await getSerial('serial');
    } catch (err) {
        logger.error('[@fingermarkglobal/serial] Error in retrieveSerialFromCache:', err);
    }
    return null;
}

export {
    persistSerialToCache,
    retrieveSerialFromCache
}